import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Register from '../pages/Register';
import EventCreate from '../pages/EventCreate';
import InvitePublic from '../pages/InvitePublic';
import InviteValidate from '../pages/InviteValidate';
import Dashboard from '../pages/Dashboard';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import PrivacyPage from '../pages/Privacy';
import Landing from '../pages/Landing';
import { useAuth } from '../contexts/AuthContext';

// Importo o contexts de autenticação para verificar o estado de autenticação do usuário e controlar o acesso às rotas protegidas e públicas da aplicação. O BrowserRouter é usado para envolver a aplicação e habilitar o roteamento.

function PrivateRoute({ children }) {
  const { signed, loadingSession } = useAuth();

  if (loadingSession) {
    return <p>Carregando sessão...</p>;
  }

  if (!signed) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

// children é uma prop especial do React que representa os elementos filhos que são passados para um componente. No caso do PrivateRoute, children representa o conteúdo que deve ser renderizado se o usuário estiver autenticado. Se o usuário não estiver autenticado, o componente redireciona para a página de login usando o componente Navigate do react-router-dom.
function PublicRoute({ children }) {
  const { signed, loadingSession } = useAuth();

  if (loadingSession) {
    return <p>Carregando sessão...</p>;
  }

  if (signed) {
    return <Navigate to="/dashboard/meus-eventos" replace />;
  }

  return children;
}

// O componente AppRoutes é o componente principal de roteamento da aplicação. Ele define as rotas usando o componente Routes do react-router-dom. As rotas são configuradas para usar os componentes PrivateRoute e PublicRoute para controlar o acesso às páginas de login, cadastro e área autenticada.
export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <Landing />
            </PublicRoute>
          }
        />
        <Route
          path="/dashboard/:tab"
          element={(
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          )}
        />
        <Route
          path="/evento/novo"
          element={(
            <PrivateRoute>
              <EventCreate />
            </PrivateRoute>
          )}
        />
        <Route path="/convite/:slug" element={<InvitePublic />} />
        <Route path="/validar/:protocol" element={<InviteValidate />} />
        <Route path="/privacidade" element={<PrivacyPage />} />
        <Route
          path="/login"
          element={(
            <PublicRoute>
              <Login />
            </PublicRoute>
          )}
        />
        <Route
          path="/esqueci-senha"
          element={(
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          )}
        />
        <Route
          path="/redefinir-senha"
          element={(
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          )}
        />
        <Route
          path="/cadastro"
          element={(
            <PublicRoute>
              <Register />
            </PublicRoute>
          )}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
